import { useState, useEffect } from 'react';
import { mobileConfigService } from '../services/mobileConfigService';

const detectPlatform = () => {
  const ua = navigator?.userAgent?.toLowerCase() || '';
  if (/iphone|ipad|ipod/?.test(ua)) return 'ios';
  if (/android/?.test(ua)) return 'android';
  return 'ios';
};

// Cache to avoid repeated DB calls across components
let cachedVisibility = null;
let cacheTimestamp = 0;
const CACHE_TTL = 30000; // 30 seconds

export const useMobileConfig = () => {
  const platform = detectPlatform();
  const [screenVisibility, setScreenVisibility] = useState({});
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const load = async () => {
      const now = Date.now();
      if (cachedVisibility && (now - cacheTimestamp) < CACHE_TTL) {
        setScreenVisibility(cachedVisibility?.[platform] || {});
        setLoaded(true);
        return;
      }
      try {
        const config = await mobileConfigService?.getScreenVisibility(platform);
        const visibility = config && typeof config === 'object' ? config : {};
        cachedVisibility = { ...(cachedVisibility || {}), [platform]: visibility };
        cacheTimestamp = now;
        setScreenVisibility(visibility);
      } catch (err) {
        console.error('Failed to load mobile config:', err);
      } finally {
        setLoaded(true);
      }
    };
    load();
  }, [platform]);

  const isScreenVisible = (screenKey) => {
    if (!loaded) return true; // show by default while loading
    return screenVisibility?.[screenKey] !== false;
  };

  return { screenVisibility, isScreenVisible, platform, loaded };
};

export default useMobileConfig;
